// extracted by mini-css-extract-plugin
export default {"headerTitle":"PieChartCard-module__headerTitle--tmTyX","chart":"PieChartCard-module__chart--bXMKe"};